import { BreadCrumbItemProps, useTranslationRoute, useTranslations } from "@harea/component"

export const useWizardDetailsBreadCrumb = (title: string): Array<BreadCrumbItemProps> => {

	const [
		HOME,
		TITLE
	] = useTranslations(i18n)
	const url = useTranslationRoute()
	
    return [
		{
			label: HOME,
			link: url('admin')
		},
		{
			label: TITLE,
			link: url('admin/wizard')
		},
		{
			label: title,
			className: 'active',
		}
	].reverse()
}

const i18n = [
	'std_home',
	'Bo.Wizard.title'
]
